import { BehaviorSubject } from "rxjs";
import { getCurrentPosition } from "../helpers/utils";
import { ensureGlobalState, logInstanceId } from "../helpers/state";
logInstanceId("store.service");
const STORE_STORAGE_KEY = 'utk_selected_store';
const GENERIC_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};
const BASE_URL = window.UNTUCKitConfig.storeLookupUrl;
export const selectedStore$ = ensureGlobalState("untuckit.selectedStore", new BehaviorSubject(null));
selectedStore$.subscribe((store) => {
    console.log("selected store", store);
    if (store) {
        try {
            sessionStorage.setItem(STORE_STORAGE_KEY, JSON.stringify(store));
        }
        catch (e) {
            console.log(e);
        }
    }
});
export async function setSelectedStore(storeHandle) {
    const cachedStoreJSON = sessionStorage.getItem(STORE_STORAGE_KEY);
    const cachedStore = cachedStoreJSON ? JSON.parse(cachedStoreJSON) : null;
    if (storeHandle && (!cachedStore || storeHandle !== cachedStore.COLLECTION_HANDLE)) {
        const store = await getStoreById(storeHandle);
        selectedStore$.next(store);
    }
    else {
        if (cachedStore) {
            selectedStore$.next(cachedStore);
        }
        else {
            let position = null;
            if (window.UNTUCKitConfig.nearbyToggle.browserBasedGeolocationToggle) {
                console.log("getting browser-based geolocation position");
                try {
                    position = await getCurrentPosition();
                }
                catch (e) {
                    console.warn("error getting browser-based geolocation position:", e.message || e);
                }
            }
            try {
                const nearestStores = await fetchNearbyStores(position === null || position === void 0 ? void 0 : position.coords.latitude, position === null || position === void 0 ? void 0 : position.coords.longitude);
                if (nearestStores) {
                    const nearestStore = nearestStores[0];
                    if (nearestStore) {
                        console.log(`nearest store found: ${nearestStore.SHOPIFY_DISPLAY_NAME}`);
                        const maxDistance = parseInt(window.UNTUCKitConfig.nearbyToggle.nearby_lookup_max_distance);
                        if (maxDistance > nearestStore.distance) {
                            selectedStore$.next(nearestStore);
                        }
                        else {
                            console.log(`skipping; closest store is ${nearestStore.distance}`);
                        }
                    }
                }
            }
            catch (e) {
                console.error("error fetching nearby stores:", e.message || e);
            }
        }
    }
}
/**
 * Fetch nearby stores from the nearby lookup URL
 * If browser-based geolocation is available, use the lat/long to fetch nearby stores.
 * Otherwise CloudFront may be used as a backup for the lat/long.
 * @param latitude - (optional) The latitude of the user's location
 * @param longitude - (optional) The longitude of the user's location
 * @returns An array of nearby stores
 */
async function fetchNearbyStores(latitude, longitude) {
    const queryParams = latitude && longitude ? `?latitude=${latitude}&longitude=${longitude}` : '';
    const res = await fetch(`${window.UNTUCKitConfig.nearbyToggle.nearby_lookup_url}${queryParams}`);
    if (!res.ok) {
        throw new Error("Error when attempting to fetch nearby stores");
    }
    const json = await res.json();
    return json === null || json === void 0 ? void 0 : json.stores;
}
export async function getStoreById(storeId) {
    const response = await fetch(`${BASE_URL}/${storeId}`, { method: 'GET', headers: GENERIC_HEADERS });
    if (!response.ok) {
        throw new Error('Error getting store.');
    }
    else {
        return await response.json();
    }
}
export async function getInventoryByStoreId(storeId) {
    const response = await fetch(`/collections/${storeId}?view=newstore`);
    if (!response.ok) {
        throw new Error(`Error getting inventory for store: ${storeId}`);
    }
    return await response.json();
}
export function sharedStoreDataMapping(store) {
    return {
        address: store.ADDRESS2.length > 0 ? store.ADDRESS + " " + store.ADDRESS2 : store.ADDRESS,
        city: store.CITY + ", " + store.STATE + " " + store.ZIP,
        storeHref: '/collections/' + store.COLLECTION_HANDLE
    };
}
